
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import HeroSection from './components/HeroSection';
import FeaturedPosts from './components/FeaturedPosts';
import BlogGrid from './components/BlogGrid';
import Newsletter from './components/Newsletter';

export default function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.alwaz.travel';
    const scripts: HTMLScriptElement[] = [];

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Blog',
        name: 'Alwaz Travels – Travel Guides & Tips',
        description: 'Expert travel guides, Umrah tips, destination advice, and Muslim-friendly travel inspiration from Alwaz Travels London.',
        url: `${siteUrl}/travel-guides`,
        publisher: {
          '@type': 'TravelAgency',
          name: 'Alwaz Travels',
          url: siteUrl,
          address: { '@type': 'PostalAddress', addressLocality: 'London', addressCountry: 'GB' },
        },
        inLanguage: 'en-GB',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Travel Guides & Tips | Umrah, Destinations & Muslim Travel | Alwaz Travels',
        description: 'Read expert travel guides from Alwaz Travels London. Tips for Umrah, halal holidays, Saudi Arabia, Turkey, Dubai, and Muslim-friendly destinations worldwide.',
        url: `${siteUrl}/travel-guides`,
        isPartOf: { '@type': 'WebSite', name: 'Alwaz Travels', url: siteUrl },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Travel Guides', item: `${siteUrl}/travel-guides` },
          ],
        },
      },
    ];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Travel Guides & Tips | Umrah, Destinations & Muslim Travel | Alwaz Travels';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Read expert travel guides from Alwaz Travels London. Tips for Umrah, halal holidays, Saudi Arabia, Turkey, Dubai, and Muslim-friendly destinations worldwide.');

    return () => {
      scripts.forEach((s) => s.parentNode?.removeChild(s));
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <FeaturedPosts />
      <BlogGrid />
      <Newsletter />
      <Footer />
    </div>
  );
}
